export default __webpack_public_path__ + "static/iAWriterDuospace-Bold-4b1aaf189e5eb3d721be0915120f2392.otf";